import axios from "axios";
import { authHeader } from "./utils";
import { GET_ORGANIZATION, LIST_ORGANIZATION } from "./types";

export const getOrg = (id) => async (dispatch) => {
  const res = await axios.get(`/api/organizations/${id}`, {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: GET_ORGANIZATION, payload: res.data });
};

export const fetchOrgs =
  ({ page, limit }) =>
  async (dispatch) => {
    const res = await axios.get("/api/organizations", {
      headers: authHeader(),
      params: { page, limit },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_ORGANIZATION, payload: res.data });
  };

export const submitOrg =
  ({ organization }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.post("/api/organizations", organization, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const updateOrg =
  ({ organization, id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(`/api/organizations/${id}`, organization, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const deleteOrg =
  ({ id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/api/organizations/${id}`, {
          headers: authHeader(),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
